

  export interface Content {
    id: number;
    provider: string;
    receivedPhoneNumber: string;
    contentSms: string;
    createdDate: Date;
    lastUpdateDate?: any;
    status?: any;
    paymentStatus?: any;
    transactionId?: any;
    ussdSessionId: string;
    sent: boolean;
  }

  export interface Sort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  }

  export interface Pageable {
    sort: Sort;
    offset: number;
    pageSize: number;
    pageNumber: number;
    unpaged: boolean;
    paged: boolean;
  }

  export interface Sort2 {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  }

  export interface Audits {
    content: Content[];
    pageable: Pageable;
    last: boolean;
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
    sort: Sort2;
    first: boolean;
    numberOfElements: number;
    empty: boolean;
  }


  export class Page<T> {
    content?: Array<T>;
    last?: boolean;
    totalElements?: number;
    totalPages?: number;
    size?: number;
    number?: number;
    first?: boolean;
    pageable?: any;
    numberOfElements?: number;
    empty?: boolean;


  }
